// src/components/SellerRoute.js
import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';
import { UserContext } from '../context/UserContext';

const SellerRoute = () => {
  const { user } = useContext(UserContext);
  const lang = useLanguage();

  // Since SellerRoute is nested within ProtectedRoute, we can assume user.isLoggedIn is true.
  // We just need to check if the logged-in user is a seller.
  // If not, redirect to the localized home page.
  return user.isSeller ? <Outlet /> : <Navigate to={`/${lang}`} />;
};
export default SellerRoute;
